import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_aggregation_strategies_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number[], fullTextSearch?: string, name?: string }): 
  Promise<{ result: { Id?: number, EnumName?: string, ForecastSupport?: boolean, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_aggregation_strategies_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number[], fullTextSearch?: string, name?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EnumName?: string, ForecastSupport?: boolean, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_aggregation_strategies_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number[], fullTextSearch?: string, name?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, EnumName?: string, ForecastSupport?: boolean, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_aggregation_strategies_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number[], fullTextSearch?: string, name?: string    }) {
      return false;
    }
}
